/**
 * @fileoverview Body Parts theme - match body part emojis (educational).
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Body Parts theme for learning anatomy basics.
 */
export class ActivitiesTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'activities',
            'Activities',
            allLabels.activities,
            { numPairs: 7, ...options }
        );
    }
}
